import {
    CONTACT_ERROR_MESSAGE,
    CONTACT_ERROR_MESSAGE_CLEAR,
    CONTACT_PENDING,
    CONTACT_SUCCESS,
    CONTACT_SUCCESS_CLEAR
} from "./constants";

const initialState = {
    isContactPending: false,
    isContactSuccess: false,
    contactErrorMessage: null,
};

const contact = (localState = initialState, action) => {
    switch (action.type) {
        case CONTACT_PENDING: {
            return {
                ...localState,
                isContactPending: true,
                isContactSuccess: false,
                contactErrorMessage: null,
            };
        }
        case CONTACT_SUCCESS: {
            return {
                ...localState,
                isContactPending: false,
                isContactSuccess: true,
                contactErrorMessage: null,
            };
        }
        case CONTACT_SUCCESS_CLEAR: {
            return {
                ...localState,
                isContactSuccess: false,
            };
        }
        case CONTACT_ERROR_MESSAGE: {
            const { errroMessage } = action.payload || {};
            return {
                ...localState,
                isContactPending: false,
                isContactSuccess: false,
                contactErrorMessage: errroMessage,
            };
        }
        case CONTACT_ERROR_MESSAGE_CLEAR: {
            return {
                ...localState,
                isContactPending: false,
                contactErrorMessage: null,
            };
        }
        default: {
            return localState;
        }
    }
};

export default contact;